import { IPrebidConfiguration } from "@almamedia/amr-adtech-stack/lib/services/prebid/prebid";

const prebid: IPrebidConfiguration = {
  enabled: true,
  defaults: {
    prebidTimeout: 800,
    rubicon: {
      singleRequest: true,
      accountId: "10101",
      siteId: "32466",
    },
    adform: {
      rcur: "USD",
    },
  },
  userSync: {
    syncDelay: 3000,
    userIds: [
      {
        name: "pubCommonId",
        bidders: ["adform", "rubicon"],
        storage: {
          type: "cookie",
          name: "_pubcid",
          expires: 60,
        },
      },
    ],
  },
  bids: {
    ros_almad_parade_1: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "547386" } },
        { bidder: "adform", params: { mid: "1036493" } },
      ],
    },
    ros_almad_rectangle_1: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "583750" } },
        { bidder: "adform", params: { mid: "1036494" } },
      ],
    },
    ros_almad_rectangle_2: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "336768" } },
        { bidder: "adform", params: { mid: "1036495" } },
      ],
    },
    ros_almad_skyscraper_1: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "1483976" } },
        { bidder: "adform", params: { mid: "1036496" } },
      ],
    },
    ros_almad_skyscraper_2: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "131284" } },
        { bidder: "adform", params: { mid: "1036497" } },
      ],
    },
    ros_almad_widerectangle_1: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "327486" } },
        { bidder: "adform", params: { mid: "1036498" } },
      ],
    },
    ros_almad_widerectangle_2: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "203936" } },
        { bidder: "adform", params: { mid: "1036499" } },
      ],
    },
    ros_almad_widerectangle_4: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "348468" } },
        { bidder: "adform", params: { mid: "1036500" } },
      ],
    },
    ros_almad_mobile_parade_1: {
      bidders: [
        { bidder: "rubicon", params: { siteId: "59724", zoneId: "323334" } },
        { bidder: "adform", params: { mid: "1036503" } },
      ],
    },
    ros_almad_mobile_parade_2: {
      bidders: [
        { bidder: "rubicon", params: { siteId: "59724", zoneId: "369390" } },
        { bidder: "adform", params: { mid: "1036504" } },
      ],
    },
    ros_almad_mobile_parade_3: {
      bidders: [
        { bidder: "rubicon", params: { siteId: "59724", zoneId: "284258" } },
        { bidder: "adform", params: { mid: "1036505" } },
      ],
    },
    ros_almad_mobile_parade_4: {
      bidders: [
        { bidder: "rubicon", params: { siteId: "59724", zoneId: "651910" } },
        { bidder: "adform", params: { mid: "1036506" } },
      ],
    },
  },
};

export default prebid;
